import script from "./MasterMaintenanceMenuList.vue?vue&type=script&setup=true&lang=ts"
export * from "./MasterMaintenanceMenuList.vue?vue&type=script&setup=true&lang=ts"

import "./MasterMaintenanceMenuList.vue?vue&type=style&index=0&id=c89b5d38&lang=css"

const __exports__ = script;

export default __exports__
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';import Ripple from 'quasar/src/directives/Ripple.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QList,QItem,QSeparator,QItemSection});qInstall(script, 'directives', {Ripple});
